export const installServiceWorker = () => {
    /* Only register a service worker if it's supported */
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service-worker.js')
            .then(function (r) {
                FL?.log?.debug('[PWA] Registered service worker.');
            })
            .catch(function (e) {
                FL.log.error('Failed to register service worker...');
                FL.log.error(e);
            });
    }
};
